import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "fr",
  style: {"margin-right":"20px","margin-top":"-8px"}
}
const _hoisted_5 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"200px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "確認")
], -1)
const _hoisted_9 = {
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_10 = {
  key: 0,
  class: "rad8 pad20 mc posRe",
  style: {"width":"340px","height":"120px"}
}
const _hoisted_11 = {
  key: 0,
  class: "warningText fs20 arial centered fw600",
  style: {"margin-top":"15px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs24" }, "🆗", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "人", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fs24" }, "🆖", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "人", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fs20" }, "❓", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "人", -1)
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "fs12 kakugo centered",
  style: {"color":"#f0ad4e"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 kakugo centered" }, " 外部のカレンダーを連携しているユーザーには自動的にカレンダーに登録されます。 ", -1)
const _hoisted_22 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_25 = {
  key: 0,
  class: "with_white_bg dgrey fs16 pointer centered w100 lgreyBg disabled",
  style: {"line-height":"50px","height":"50px"}
}
const _hoisted_26 = {
  key: 0,
  class: "fs14 fw400"
}
const _hoisted_27 = {
  key: 1,
  class: "fs14 fw400"
}
const _hoisted_28 = {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}
const _hoisted_29 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_ScheduleSlideContent = _resolveComponent("ScheduleSlideContent")!
  const _component_AdLimitFree = _resolveComponent("AdLimitFree")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "confirmFixScheduleModal",
    "content-class": "rad10 with_white_bg shadowContent modalWide noscroll FixScheduleModal",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideFixScheduleModal && _ctx.hideFixScheduleModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        (!_ctx.Util.isPreview() && _ctx.canFix)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "pointer centered circle_button pinkBg fs14 rad8 fw600",
                style: {"width":"220px","height":"44px","padding":"11px 8px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fixSchedule && _ctx.fixSchedule(...args)))
              }, [
                _createTextVNode(" この日程で確定 "),
                (_ctx.selectedMag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createTextVNode(" （選択中: "),
                      (_ctx.selectedMag.profile_image_urls && _ctx.selectedMag.profile_image_urls[0])
                        ? (_openBlock(), _createBlock(_component_UserIcon, {
                            key: 0,
                            width: 24,
                            canEdit: false,
                            imageUrl: _ctx.selectedMag.profile_image_urls[0],
                            style: `display:inline-block;`,
                            tooltipName: _ctx.selectedMag.team_name,
                            showTooltip: true
                          }, null, 8, ["imageUrl", "tooltipName"]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                            width: "30",
                            height: "30",
                            style: {"margin-top":"-5px"}
                          }, null, 8, _hoisted_6)),
                      _createTextVNode(" ） ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createElementVNode("div", {
          class: "ofs",
          style: _normalizeStyle(`height: ${_ctx.contentHeight};overscroll-behavior: contain;`)
        }, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_ctx.currentPd)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("p", {
                    class: "warningText fs20 arial centered fw600",
                    style: _normalizeStyle(`${_ctx.from == `schedule` ? `` : `margin-top:23px;`}`)
                  }, _toDisplayString(_ctx.currentPd.jp_format), 5),
                  (_ctx.from == `schedule` && _ctx.currentUnknownAttendees)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                        _withDirectives((_openBlock(), _createElementBlock("span", null, [
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(_ctx.currentAttendees.length) + " ", 1),
                          _hoisted_13
                        ])), [
                          [_directive_tooltip, 
                                    _ctx.currentAttendees
                                        ? _ctx.currentAttendees
                                              .map(att => `${att.is_company ? `${att.company_name} ` : ``}${att.name}`)
                                              .join(`\n`)
                                        : null
                                ]
                        ]),
                        _createTextVNode("    "),
                        _withDirectives((_openBlock(), _createElementBlock("span", null, [
                          _hoisted_14,
                          _createTextVNode(" " + _toDisplayString(_ctx.currentNotAttendees.length) + " ", 1),
                          _hoisted_15
                        ])), [
                          [_directive_tooltip, 
                                    _ctx.currentNotAttendees
                                        ? _ctx.currentNotAttendees
                                              .map(att => `${att.is_company ? `${att.company_name} ` : ``}${att.name}`)
                                              .join(`\n`)
                                        : null
                                ]
                        ]),
                        _createTextVNode("    "),
                        _withDirectives((_openBlock(), _createElementBlock("span", null, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.currentUnknownAttendees.length) + " ", 1),
                          _hoisted_17
                        ])), [
                          [_directive_tooltip, 
                                    _ctx.currentUnknownAttendees
                                        ? _ctx.currentUnknownAttendees
                                              .map(att => `${att.is_company ? `${att.company_name} ` : ``}${att.name}`)
                                              .join(`\n`)
                                        : null
                                ]
                        ]),
                        _createTextVNode("  ")
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pdIndexType != `first`)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "posAb pointer",
                        style: {"left":"0","top":"40px"},
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showBeforePossibleDate && _ctx.showBeforePossibleDate(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                          width: "27",
                          height: "30"
                        }, null, 8, _hoisted_18)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pdIndexType != `last`)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "posAb pointer",
                        style: {"right":"0","top":"40px"},
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showAfterPossibleDate && _ctx.showAfterPossibleDate(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_right.png`),
                          width: "27",
                          height: "30"
                        }, null, 8, _hoisted_19)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.from == `schedule` && _ctx.room && _ctx.pdm && (_ctx.pdm.sharedMembers || []).length < _ctx.room.members.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, " ※ 調整カレンダーを共有していないメンバーがいるため、参加できるか不明です。 "))
              : _createCommentVNode("", true),
            _hoisted_21
          ]),
          _createVNode(_component_ScheduleSlideContent, {
            from: _ctx.from,
            style: `margin-top:20px;`,
            onSelect: _ctx.selectMag
          }, null, 8, ["from", "onSelect"])
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          (_ctx.Util.isPreview() || !_ctx.canFix)
            ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                (_ctx.Util.isPreview())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "プレビューのため確定できません"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_27, "現在確定できません"))
              ]))
            : (_openBlock(), _createElementBlock("section", {
                key: 1,
                id: "roomCloseButton",
                class: "w100 pinkBg fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fixSchedule && _ctx.fixSchedule(...args)))
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createTextVNode(" この日程で確定 "),
                  (_ctx.selectedMag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createTextVNode(" （選択中: "),
                        (_ctx.selectedMag.profile_image_urls && _ctx.selectedMag.profile_image_urls[0])
                          ? (_openBlock(), _createBlock(_component_UserIcon, {
                              key: 0,
                              width: 24,
                              canEdit: false,
                              imageUrl: _ctx.selectedMag.profile_image_urls[0],
                              style: `display:inline-block;margin-top:-3px;`,
                              tooltipName: _ctx.selectedMag.team_name,
                              showTooltip: true
                            }, null, 8, ["imageUrl", "tooltipName"]))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                              width: "30",
                              height: "30",
                              style: {"margin-top":"-5px"}
                            }, null, 8, _hoisted_30)),
                        _createTextVNode(" ） ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ])
      ]),
      _createVNode(_component_AdLimitFree, {
        showAds: _ctx.showAds,
        addFrom: `日程確定モーダル`,
        onFadeOutAdModal: _ctx.fadeOutAdModal
      }, null, 8, ["showAds", "onFadeOutAdModal"])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}